/*
There are 2 types of popups:

1. Local Popups
Local popups are created as regular components directly by any component that needs a popup. It usually
resides within tha parent's component's tree and its layer and visibility is controlled solely by its parent
component. Thus, data exchange may occur between parent and popup via props or contexts.

Local popup has its own overlay and positioning container (these are added in 'LocalPopup' wrapper). Generally speaking,
you can use any arbitrary component as Local Popup with or without 'LocalPopup' wrapper.

Examples: DateSpanPicker/Picker, Comppoints/ConvertPopup, Games/Filters/PayOutVolatility/Info

2. Global Popups (managed popups)
Global popups are different in a way that they do not belong to their parent. They are _managed_ by popup manager
(currently, it's in Popups dir), they are rendered into popups manager's tree to a specific Layer.
Popup manager controls when to show this popups, their visibility, order and other behavior. Popup parent has little
control over popup itself, and popup content is usually self-sufficient component. To show such popup parent has to
dispatch an action to popups manager context. Data exchange between parent and such popup via context or props is
impossible.

Global popups are usually created using ShallowPopup as base, wrapping it in some custom component, dispatching action
to Popup Manager with this custom component in payload. Also, each custom managed popup must have assigned layer in
which it will be shown (see 'layers.js'). Layers control visibility of managed popups over each other, create new layer
if existing ones do not fit your needs.

Most popups are global.
@example AdvancedPlayerMessage, GamesInfo, LightBox
 */

export { LocalPopup } from './LocalPopup';
export { ShallowPopup } from './ShallowPopup';
export { ManagedPopup } from './ManagedPopup';
